import { Available, BankHoliday, CollectionDate, KeyBoxDesc, KeyBoxItem, KeyContainer, ReturnDate, Selected, Unavailable } from 'Components/Calendar/KeyComponents';
import { calendarConfig } from 'Components/Constants';
import React from 'react';

function DatesCalender() {

    return (
        <>
            <KeyContainer>
                <KeyBoxItem>
                    <Available/>
                    <KeyBoxDesc>Available</KeyBoxDesc>
                </KeyBoxItem>
                {calendarConfig.getUnavailableDates &&
                    <KeyBoxItem>
                        <Unavailable />
                        <KeyBoxDesc>Unavailable</KeyBoxDesc>
                    </KeyBoxItem>
                }
                <KeyBoxItem>
                    <Selected />
                    <KeyBoxDesc>Selected</KeyBoxDesc>
                </KeyBoxItem>
                <KeyBoxItem>
                    <CollectionDate />
                    <KeyBoxDesc>Collection Date</KeyBoxDesc>
                </KeyBoxItem>
                <KeyBoxItem>
                    <ReturnDate />
                    <KeyBoxDesc>Return Date</KeyBoxDesc>
                </KeyBoxItem>
                <KeyBoxItem>
                    <BankHoliday />
                    <KeyBoxDesc>Bank Holiday</KeyBoxDesc>
                </KeyBoxItem>
            </KeyContainer>
        </>
    );
}
export default DatesCalender;
